import { ConnectorId } from "../domain/ConnectorId";
import { ConnectorIdRepository } from "../domain/ConnectorIdRepository";
import { VueConnectorIdsScreenData } from "../infra/VueConnectorIdsScreenData";

export class ConnectorIdsScreen {
    screen_data: VueConnectorIdsScreenData;
    connector_ids_repo: ConnectorIdRepository;
    user_id: Number;
    
    constructor(connector_ids_repo: ConnectorIdRepository, screen_data: VueConnectorIdsScreenData, user_id: Number){
        this.connector_ids_repo = connector_ids_repo 
        this.screen_data = screen_data
        this.user_id = user_id
    }

    async fetch_all_connector_ids(user_id:Number) {
        let connectors: ConnectorId[]
        connectors = await this.connector_ids_repo.getConnectors(user_id)
        this.screen_data.data = connectors
    }

    async set_current_connector(user_id:Number, connector_name:String) {
        this.screen_data.loadingSetCurrent = true
        await this.connector_ids_repo.setCurrentConnector(user_id, connector_name)
        if (this.screen_data.newName) {
            this.screen_data.data.push(new ConnectorId(user_id, this.screen_data.newName, false))
            this.screen_data.newName = ''
        }
        this.screen_data.data.forEach(c => {
            if (c.name === connector_name) {
                c.current = true
            } else {
                c.current = false
            }
        })
        // await this.fetch_all_connector_ids(user_id)
        this.screen_data.newName = ''
        this.screen_data.loadingSetCurrent = false
    }
}